import { Title } from '@/components/Typography'
import { Languages } from '@/constant/language'
import { COMMON_TEXT } from '@/config/translation/text'
import { JSONStringify } from '@/utils/common'
import { Select } from 'antd'
import { useTranslation } from 'react-i18next'

import { find as _find } from 'lodash'
import { getLocale, setLocale } from '@/utils/local'

export interface UserLanguage {}

export function UserLanguage({}: UserLanguage) {
  const { t, i18n } = useTranslation()

  const _changeLanguage = (values) => {
    i18n.changeLanguage(JSON.parse(values).code)
    setLocale(JSON.parse(values).code)
  }

  const _getDefaultLanguage = () =>
    JSONStringify(
      _find(Languages, (item) => item.code == getLocale()) || Languages[0]
    )

  return (
    <>
      <Title level={3}>{t(COMMON_TEXT.LANGUAGES)}</Title>
      <Select
        style={{ width: 300 }}
        size="large"
        defaultValue={_getDefaultLanguage}
        onChange={_changeLanguage}
      >
        {Languages.map((item) => {
          return (
            <Select.Option key={item.key} value={JSONStringify(item)}>
              {item.name}
            </Select.Option>
          )
        })}
      </Select>
    </>
  )
}
